app.controller('libraryController', function($http, $scope, $rootScope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller, anchorSmoothScroll) {

	//Include custom controller functionality
	$controller('userDefinedLibraryController', {$scope: $scope, $stateParams: $stateParams});
	
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);

        //Get user permissions from rootscope(angular config)
        $scope.can_edit_library = typeof $rootScope.can_edit_library != 'undefined' && $rootScope.can_edit_library == 'yes'?true:false;
        $scope.can_delete_library = $rootScope.can_delete_library != 'undefined' && $rootScope.can_delete_library == 'yes'?true:false;
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}
	
	//=======page specific methods and processes==========//
    $scope.display_advanced_search = ($scope.filter_5.selected_value || $scope.filter_6.selected_value || $scope.filter_4.selected_value != 'all_these_words') ? 1 : 0;
    $scope.toggleAdvancedSearch = function(){
        $scope.display_advanced_search = $scope.display_advanced_search == 0 ?1:0;
    }

	//Function to display the Add action dialog
    $scope.showFilePreview = function(id, component_key)
    {
        $scope.id = typeof id !== 'undefined'?id:null;
        $scope.component_key = component_key;
        var components = typeof pageConfig.components !== 'undefined' ? pageConfig.components:null;
        var component = typeof components[component_key] !== 'undefined' ? components[component_key] :null;

        if(id && component_key)
        {
            //Edit Functionality
            var post_data = {};
            post_data['selectkey'] = component.config.transcript_key;
            post_data['selectvalue'] = id;
            // var component = $scope[component_key];
            var selectsurveykey = typeof(component.survey_key !== 'undefined') ? component.survey_key : null;
            post_data['selectsurveyvalue'] = selectsurveykey;
            post_data['app_state'] = $scope.appState;

            //Get the record from db
            dataService.getData(component.config.transcript_url, post_data , 'POST')
                .then(function(response) {
                        if(typeof(response) !== 'undefined')
                        {
                            // $rootScope.previousSidebar = response.data;
                            // console.log(response);
                            // $scope.recordDetails = response.data.additional;
                            $scope.recordDetails = {
                                "project_name" : response.data.additional.app_metric_2.value,
                                "pseudo_name" : response.data.additional.app_metric_3.value,
                                "filename" : response.data.additional.app_metric_4.value,
                                "location" : response.data.additional.app_metric_5.value,
                                "type" : response.data.additional.app_metric_6.value,
                                "month" : response.data.additional.app_metric_7.value,
                                "year" : response.data.additional.app_metric_8.value,
                                "description" : response.data.additional.app_metric_9.value,
                                "synopsis" : response.data.additional.app_metric_10.value,
                                "tags" : response.data.additional.app_metric_22.value
                            };
                            var modalInstance = $modal.open({
                                templateUrl: 'views\/library_preview.html',
                                controller: UploadCtrl,
                                scope : $scope,
                                windowClass : 'upload_form_window'
                            });
                        }
                        else{
                            //Error
                        }
                    }
                );
        }
    }

    $scope.showUploadForm = function(id, component_key, action)
	{
        $scope.recordDetails = {
            "project_name" : "",
            "pseudo_name" : "",
            "filename" : "",
            "location" : "",
            "type" : "",
            "month" : "",
            "year" : "",
            "description" : "",
            "synopsis" : "",
            "business_unit_commissioned" : "",
            "stakeholder" : "",
            "market_research" : "",
            "research_manager" : "",
            "external_agency" : "",
            "product_category" : "",
            "brand" : "",
            "segment" : 0,
            "strategic_pillar" : 0,
            "type_of_research" : 0,
            "moment" : "",
            "tags" : "",
            "file_upload_max_size": "",
            "file_upload_max_size_display": ""
        };

        //Get the parameters for the Upload Form
        var newState = angular.copy($scope.appState);
        dataService.getData('library/get_upload_params', {'app_state' : newState} , 'POST')
            .then(function(response) {
                    if(typeof(response['options']) !== 'undefined')
                    {
                        $scope.uploadParams = response['options'];
                    }
                    if(typeof(response['defaults']) !== 'undefined')
                    {
                        var defaults = response['defaults'];
                        if(typeof(defaults['month']) !== 'undefined'){
                            $scope.recordDetails['month'] = defaults['month'];
                        }
                        if(typeof(defaults['year']) !== 'undefined'){
                            $scope.recordDetails['year'] = defaults['year'];
                        }
                        if(typeof(defaults['uploader']) !== 'undefined'){
                            $scope.recordDetails['research_manager'] = defaults['uploader'];
                        }

                        if(typeof(defaults['file_upload_max_size']) !== 'undefined'){
                            $scope.recordDetails['file_upload_max_size'] = defaults['file_upload_max_size'];
                        }
                        if(typeof(defaults['file_upload_max_size_display']) !== 'undefined'){
                            $scope.recordDetails['file_upload_max_size_display'] = defaults['file_upload_max_size_display'];
                        }
                    }

                    //Populate the form once you receive the default upload params
                    $scope.action = typeof action !== 'undefined'?action:null;
                    $scope.id = typeof id !== 'undefined'?id:null;
                    $scope.component_key = component_key;
                    // console.log(pageConfig);
                    var components = typeof pageConfig.components !== 'undefined' ? pageConfig.components:null;
                    var component = typeof components[component_key] !== 'undefined' ? components[component_key] :null;
                    

                    if(id && component_key)
                    {
                        //Edit Functionality
                        var post_data = {};
                        post_data['selectkey'] = component.config.transcript_key;
                        post_data['selectvalue'] = id;
                        // var component = $scope[component_key];
                        var selectsurveykey = typeof(component.survey_key !== 'undefined') ? component.survey_key : null;
                        post_data['selectsurveyvalue'] = selectsurveykey;
                        post_data['app_state'] = $scope.appState;

                        //Get the record from db
                        dataService.getData(component.config.transcript_url, post_data , 'POST')
                            .then(function(response) {
                                    if(typeof(response) !== 'undefined')
                                    {
                                        // $rootScope.previousSidebar = response.data;
                                        // console.log(response);
                                        // $scope.recordDetails = response.data.additional;
                                        $scope.recordDetails = {
                                            "project_name" : response.data.additional.app_metric_2.value,
                                            "pseudo_name" : response.data.additional.app_metric_3.value,
                                            "filename" : response.data.additional.app_metric_4.value,
                                            "location" : response.data.additional.app_metric_5.value,
                                            "type" : response.data.additional.app_metric_6.value,
                                            "month" : response.data.additional.app_metric_7.value,
                                            "year" : response.data.additional.app_metric_8.value,
                                            "description" : response.data.additional.app_metric_9.value,
                                            "synopsis" : response.data.additional.app_metric_10.value,
                                            "business_unit_commissioned" : response.data.additional.app_metric_11.value,
                                            "stakeholder" : response.data.additional.app_metric_12.value,
                                            "market_research" : response.data.additional.app_metric_13.value,
                                            "research_manager" : response.data.additional.app_metric_14_label.value,
                                            "external_agency" : response.data.additional.app_metric_15.value,
                                            "product_category" : response.data.additional.app_metric_16.value,
                                            "brand" : response.data.additional.app_metric_17.value,
                                            "segment" : response.data.additional.app_metric_18.value,
                                            "strategic_pillar" : response.data.additional.app_metric_19.value,
                                            "type_of_research" : response.data.additional.app_metric_20.value,
                                            "moment" : response.data.additional.app_metric_21.value,
                                            "tags" : response.data.additional.app_metric_22.value
                                        };
                                        var modalInstance = $modal.open({
                                            templateUrl: 'views\/library_upload.html',
                                            controller: UploadCtrl,
                                            scope : $scope,
                                            windowClass : 'upload_form_window'
                                        });
                                    }
                                }
                            );
                    }
                    else{
                        //Add Functionality
                        var modalInstance = $modal.open({
                            templateUrl: 'views\/library_upload.html',
                            controller: UploadCtrl,
                            scope : $scope,
                            windowClass : 'upload_form_window'
                        });
                    }

                    //End
                }
            );

        
	}

	//Bind click events for action links
    $( ".panel-body" ).on( "click", "tbody button, tbody a", function() {
    	var id = $( this ).data('id');
    	var action = $( this ).data('action');
    	var component_key = $( this ).data('component');

        if(action === 'share')
        {
        	//
            // console.log("Share Item: "+id);
            $scope.component_key = component_key;
            
            var url = $location.absUrl().split('#')[0];
            $scope.full_url = url+'share?key=';
            $scope.share_file_id = id;
            //Show delete confirmation dialog
            var modalInstance = $modal.open({
                templateUrl: 'views\/library_share.html',
                controller: ShareCtrl,
                scope : $scope,
                windowClass : 'confirmation_window'
            });
        }
        else if(action === 'view'){
            //Display the upload Form
            $scope.showUploadForm(id, component_key, action);
        }
        else if(action === 'edit'){
        	//Display the upload Form
            $scope.showUploadForm(id, component_key, action);
        }
        else if(action === 'delete'){
            $scope.component_key = component_key;
        	//Show delete confirmation dialog
        	var modalInstance = $modal.open({
        		template: '<div class="modal-body">'+
        		'Are you sure you want to delete this entry?'+
        		'</div>'+
        		'<div class="modal-footer">'+
        		'<button type="button" data-dismiss="modal" ng-click="confirm_delete('+id+')" class="btn btn-primary" id="delete">Delete</button>'+
        		'<button type="button" data-dismiss="modal" ng-click="cancel()" class="btn">Cancel</button>'+
        		'</div>',
        		controller: DeleteConfirmationCtrl,
        		scope : $scope,
        		windowClass : 'confirmation_window'
        	});
        }
        else if(action == 'preview'){
            //Display the file preview
            $scope.showFilePreview(id, component_key);
        }
    });

    /** ----------------- Notification Listeners --------------- **/
    //Event Listener to perform the view action of a record
    $scope.$on('ViewLibraryItem', function(event, args) {
        $scope.showUploadForm(args.target_item, 'component_1', 'view');
    });

    $timeout(function(){
        // console.log($rootScope.target_item);
        if($rootScope.target_item){
            //Found
            $scope.showUploadForm($rootScope.target_item, 'component_1', 'view');
            $rootScope.target_item = false;
        }
    }, 2000);
    /** ----------------- Notification Listeners Ends --------------- **/
    

    //Controller for Add/Edit action dialog
	function UploadCtrl($http, $q, $scope, $modalInstance, $modal, $timeout) {
		//
        $scope.loading = false;
        $scope.file_analysis_in_progress = false;
        $scope.tags = [];
        $scope.suggestions = [];

        $scope.deleteItem = function(id, component_key) {
            $modalInstance.close();
            // call the delete confirmation
           $scope.show_delete_popup();
        }

        $scope.getTags = function(){
            var tags_only = Array.prototype.map.call($scope.tags, function(item) { return item.text; });
            return JSON.stringify(tags_only);
        }
        $scope.updateTags = function(tag_string){
            function IsJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            }
            if(IsJsonString(tag_string))
            {
              //the json is ok
                var tagobject = angular.fromJson(tag_string);
                var tags_object = Array.prototype.map.call(tagobject, function(item) { return {"text":item};});
                $scope.tags = tags_object;
                // console.log(tags_object);
            }else{
              //the json is not ok
              // console.log("invalid json");
            }
        }
        $scope.pushTag = function(tag_value){
            //get the added tags
            var tags_only = Array.prototype.map.call($scope.tags, function(item) { return item.text; });
            if(tags_only.indexOf(tag_value) === -1) {
                $scope.tags.push({"text":tag_value});
            }
            
        }

		$scope.submit = function() {
            $scope.loading = true;
            var component_key = $scope.component_key;
            var formData = new FormData(document.getElementById('uploadForm'));

            //Add the id if available
            if($scope.id){
                formData.append('id', $scope.id);
            }
            //Add the tags field
            formData.append('Tags', $scope.getTags());

            var deferred = $q.defer();
            $http.post('library/save', formData, {
                cache: false,
                contentType: false,
                processData: false,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            })
                .success(function (response) {
                    $scope.loading = false;
                    deferred.resolve(response);
                    $scope[component_key].instance.rerender(); //reload the data table
                    $modalInstance.close();
                })
                .error(function (reject) {
                    $scope.loading = false;
                    deferred.reject(reject);
                });
            return deferred.promise;
	    };

	    $scope.cancel = function() {
	        $modalInstance.dismiss('cancel');
	    };

        $scope.clear_input = function () {
            // console.log("Clear input field");
            angular.element(document.querySelector('#attachment_file')).val(null);
            $scope.fileModel = null;
            $scope.recordDetails.filename = '';
            $scope.suggestions = [];
        };

        $scope.fileOnSelect = function(event){
            // console.log('custom on change function for file');
            if(!$scope.fileModel){
                //Check if no file is selected
                // console.log("No Valid File");
                return false;
            }
            $scope.file_analysis_in_progress = true;
            var timer;
            $scope.counter = 0;
            $scope.stopCounter = function() {
                $timeout.cancel(timer);
            };
            var updateCounter = function() {
                $scope.counter++;
                if($scope.counter < 40){
                    timer = $timeout(updateCounter, 200);
                }

            };
            updateCounter();

            //check if it is an allowed file extension




            //TODO: Post data to backend to generate tags
            var component_key = $scope.component_key;
            var formData = new FormData(document.getElementById('uploadForm'));

            //Add the id if available
            /*if($scope.id){
                formData.append('id', $scope.id);
            }*/
            //Add the tags field
            // formData.append('Tags', $scope.getTags());

            // var deferred = $q.defer();
            $http.post('library/evaluate', formData, {
                cache: false,
                contentType: false,
                processData: false,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            })
            .success(function (response) {
                // deferred.resolve(response);
                $timeout(function(){
                    $scope.counter = 100;
                    $scope.file_analysis_in_progress = false; //Hide the inprogress
                    //Add the suggestions
                    var suggestion_list = typeof response.file != 'undefined' && typeof response.file.Suggestation != 'undefined'?response.file.Suggestation:[];
                    suggestion_list = JSON.parse(suggestion_list);
                    $scope.suggestions = suggestion_list.length > 0 ? suggestion_list : [];
                    // console.log($scope.suggestions);
                }, 1000);
                /*console.log(response);
                $scope.suggestions = response.file.Suggestation;
                console.log($scope.suggestions);
                $scope.counter = 100;
                $scope.file_analysis_in_progress = false; *///Hide the inprogress
            })
            .error(function (reject) {
                // deferred.reject(reject);
                //Failed to evaluate the file
                $scope.counter = 100;
                $scope.file_analysis_in_progress = false; //Hide the inprogress
                $scope.suggestions = [];
            });
            // return deferred.promise;

            //On response, display the file & populate the tags
            $timeout(function(){
                $scope.counter = 95;
                $timeout(function(){
                    $scope.counter = 100;
                    $scope.file_analysis_in_progress = false; //Hide the inprogress
                }, 20000);
            }, 10000);
        }

        $scope.cancelAnalysis = function(){
            $scope.file_analysis_in_progress = false;
            $scope.counter = 0;
            //TODO: Cancel the request sent to the server

            //Cancel the file if analysis is not complete
            $scope.clear_input();
        }
	}

    //function to load the delete popup from the view popup
    $scope.show_delete_popup = function(){
        // $scope.component_key = component_key;
        var id = $scope.id;
        //Show delete confirmation dialog
        var modalInstance2 = $modal.open({
            template: '<div class="modal-body">'+
            'Are you sure you want to delete this entry?'+
            '</div>'+
            '<div class="modal-footer">'+
            '<button type="button" data-dismiss="modal" ng-click="confirm_delete('+id+')" class="btn btn-primary" id="delete">Delete</button>'+
            '<button type="button" data-dismiss="modal" ng-click="cancel()" class="btn">Cancel</button>'+
            '</div>',
            controller: DeleteConfirmationCtrl,
            scope : $scope,
            windowClass : 'confirmation_window'
        });
    }

    //Controller for delete confirmation dialog
	function DeleteConfirmationCtrl($http, $q, $scope, $modalInstance, $timeout) {
	    $scope.confirm_delete = function(id){

            var component_key = $scope.component_key;
	    	var formData =  new FormData();
	    	// formData.append('id', id);
			var deferred = $q.defer();
			$http.post('library/delete?id='+id, formData, {
				cache: false,
				contentType: false,
				processData: false,
				transformRequest: angular.identity,
				headers: {'Content-Type': undefined}
			})
			.success(function (response) {
				deferred.resolve(response);
				$scope[component_key].instance.rerender(); //reload the data table //TODO: fetch component id dynamically
				$modalInstance.close(); //close the modal
				//display alert
			})
			.error(function (reject) {
				deferred.reject(reject);
			});

			$modalInstance.close();
			return deferred.promise;
	    }

	    $scope.cancel = function() {
	        $modalInstance.dismiss('cancel');
	    };
	}

    function ShareCtrl($http, $q, $scope, $modalInstance, $timeout) {
        //
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        $scope.share_key ='';
        $scope.generateShareKey = function () {
            //Send a request to update the user's last read notification time
            var appState = angular.copy($scope.appState);
            var file_id = $scope.share_file_id;
            dataService.getData('library/get_share_url', {'app_state' : appState, 'file_id' : file_id} , 'POST')
            .then(function(response) {
                if(typeof(response.data) !== 'undefined')
                {
                    //Success
                    $scope.share_key = response.data['share_key'];
                }
            });
        }
        $scope.generateShareKey();

    }

	
	
});
